// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"df6df43a","374":"e2a53524","536":"04c2d1d6","850":"db2ecb8c"}[chunkId] + ".chunk.js";
};